// When response Data is in String Formate like 16-04-2026 then use this function to show in the Calender
export const parseDateInput = (value) => {
  if (!value) return null;

  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value;
  }

  if (typeof value === "string") {
    const ddMmYyyy = value.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/);
    if (ddMmYyyy) {
      return new Date(
        Number(ddMmYyyy[3]),
        Number(ddMmYyyy[2]) - 1,
        Number(ddMmYyyy[1])
      );
    }

    const yyyyMmDd = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (yyyyMmDd) {
      return new Date(
        Number(yyyyMmDd[1]),
        Number(yyyyMmDd[2]) - 1,
        Number(yyyyMmDd[3])
      );
    }
  }

  const parsedDate = new Date(value);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

const formatWithPattern = (date, pattern) => {
  const map = {
    YYYY: String(date.getFullYear()),
    MMM: date.toLocaleString("en-GB", { month: "short" }),
    MM: String(date.getMonth() + 1).padStart(2, "0"),
    DD: String(date.getDate()).padStart(2, "0"),

    HH: String(date.getHours()).padStart(2, "0"),
    hh: String(date.getHours() % 12 || 12).padStart(2, "0"),
    mm: String(date.getMinutes()).padStart(2, "0"),
    ss: String(date.getSeconds()).padStart(2, "0"),
    A: date.getHours() >= 12 ? "PM" : "AM",
  };

  return pattern.replace(
    /YYYY|MMM|MM|DD|HH|hh|mm|ss|A/g,
    (match) => map[match]
  );
};

export const formatDateDynamic = (
  value,
  pattern = "DD/MMM/YYYY",
  fallback = "N/A"
) => {
  const parsedDate = parseDateInput(value);
  if (!parsedDate) return fallback;
  return formatWithPattern(parsedDate, pattern);
};

export const formatDateInIST = (value, pattern = "DD-MM-YYYY", fallback = "") => {
  if (!value) return fallback;

  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  })
    .format(value)
    .split("/");

  if (parts.length !== 3) return fallback;

  const [day, month, year] = parts;
  const istDate = new Date(Number(year), Number(month) - 1, Number(day));
  return formatWithPattern(istDate, pattern);
};

// To Display Date in DD-MMM-YYYY format like 16-Apr-2026
export const formatAnyDateToDisplay = (value,withTime=false, fallback = "N/A") =>
  formatDateDynamic(value, withTime?"DD-MMM-YYYY HH:mm":"DD-MMM-YYYY", fallback);

export const formatDate = (dateString) => formatAnyDateToDisplay(dateString);

// To Send Date in Payload in DD-MM-YYYY format like 16-04-2026
export const formatDateForPayload = (value, fallback = "") =>
  formatDateDynamic(value, "DD-MM-YYYY", fallback);

// To validate if endDate is before startDate
export const validateDateRange = (startDate, endDate) => {
  if (!startDate || !endDate) return { isValid: true, error: "" };
  const start = parseDateInput(startDate);
  const end = parseDateInput(endDate);

  if (!start || !end) return { isValid: true, error: "" };

  if (start.getTime() > end.getTime()) {
    return { isValid: false, error: "End Date cannot be before Start Date" };
  }
  return { isValid: true, error: "" };
};